<!-- Miolo compartilhado de "Solicitar Contador" (sem page-header/form-card externo) -->

<!-- Loading -->
<div *ngIf="loading" class="estado-inline">
  <i class="pi pi-spinner pi-spin"></i>
  <span>{{ 'contador.solicitar.carregando' | translate }}</span>
</div>

<!-- Erro de carga -->
<div *ngIf="!loading && erroCarregar" class="estado-vazio">
  <i class="pi pi-exclamation-triangle estado-erro-icon"></i>
  <p>{{ 'contador.solicitar.erro_carregar' | translate }}</p>
  <button pButton
    [label]="'contador.solicitar.tentar_novamente' | translate"
    icon="pi pi-refresh"
    class="btn-primary btn-sm"
    (click)="carregarSituacao()">
  </button>
</div>

<!-- Ja e contador -->
<div *ngIf="!loading && !erroCarregar && situacao?.contador" class="estado-vazio">
  <i class="pi pi-check-circle estado-ok-icon"></i>
  <p>{{ 'contador.solicitar.ja_contador' | translate }}</p>
  <button *ngIf="!embutido" pButton
    [label]="'contador.solicitar.ir_para_area' | translate"
    icon="pi pi-arrow-right"
    class="btn-primary btn-sm"
    (click)="irParaArea()">
  </button>
</div>

<!-- Solicitacao em analise -->
<div *ngIf="!loading && !erroCarregar && !situacao?.contador && situacao?.solicitacaoPendente"
  class="estado-em-analise">
  <div class="em-analise-icone">
    <i class="pi pi-hourglass"></i>
  </div>
  <h3 class="em-analise-titulo">{{ 'contador.solicitar.em_analise_titulo' | translate }}</h3>
  <p class="em-analise-texto">{{ 'contador.solicitar.em_analise' | translate }}</p>
  <p-tag
    [value]="'contador.status.PENDENTE' | translate"
    severity="warning">
  </p-tag>
</div>

<!-- Formulario de solicitacao -->
<div *ngIf="!loading && !erroCarregar && !situacao?.contador && !situacao?.solicitacaoPendente"
  class="form-solicitar">
  <div class="form-field full">
    <label class="form-label">{{ 'contador.solicitar.observacao_label' | translate }}</label>
    <textarea pInputTextarea
      class="w-full"
      [(ngModel)]="observacao"
      [rows]="4"
      maxlength="500"
      [placeholder]="'contador.solicitar.observacao_placeholder' | translate"
      [disabled]="enviando">
    </textarea>
  </div>

  <div class="form-actions">
    <button pButton
      [label]="'contador.solicitar.botao_solicitar' | translate"
      icon="pi pi-send"
      class="btn-primary"
      [disabled]="enviando"
      [loading]="enviando"
      (click)="solicitar()">
    </button>
  </div>
</div>

<p-toast />
